// lbl.profile
export const profile = {
    whopper_level: 'Whopper {0} Level',
    have_crowns: 'คุณมี {0}',
    point_description: 'สะสมอีก {0} คราวพอยท์ ภายในวันที่ {1} เพื่อได้รับสิทธิ {2}',
    point_history: 'ประวัติคะแนน',
    benefits: 'สิทธิพิเศษระดับขั้นวอปเปอร์',
    facebook: 'เฟซบุ๊ก',
    connect: 'เชื่อมต่อ',
    address: 'ที่อยู่',
    credit: 'เครดิต / เดบิต',
    tax_invoice: 'ที่อยู่ใบกำกับภาษี',
    my_favorite: 'รายการโปรด',
    change_mobile_pin: 'เปลี่ยนรหัสผ่าน',
    language: 'ตั้งค่าภาษา',
    en: 'EN',
    th: 'TH',
    stores: 'สาขาทั้งหมด',
    contact_us: 'ติดต่อเรา',
    term_and_condition: 'ข้อกำหนดและเงื่อนไข',
    privacy_statement: 'คำชี้แจงสิทธิส่วนบุคคล',
    fresh_taste: 'Fresh Taste',
    catering: 'Catering',
    made_to_order: 'Made to Order',
    promotion: 'Promotion',
    sign_out: 'ออกจากระบบ',
    my_coupon: 'คูปองของฉัน',
    register_to_privilege: 'ลงทะเบียนเพื่อรับสิทธิพิเศษ',

    firstname: {
        name: 'ชื่อ',
        placeholder: 'ชื่อ',
        required: 'กรุณากรอกชื่อ',
        too_short: '',
        invalid: '',
    },
    lastname: {
        name: 'นามสกุล',
        placeholder: 'นามสกุล',
        required: 'กรุณากรอกนามสกุล',
        too_short: '',
        invalid: '',
    },
    contactNumber: {
        name: 'เบอร์โทรศัพท์',
        placeholder: 'เบอร์โทรศัพท์',
        required: 'กรุณากรอกเบอร์โทรศัพท์',
        too_short: 'เบอร์โทรศัพท์ต้องมี {0} หลัก',
        invalid: 'เบอร์โทรศัพท์ไม่ถูกต้อง',
    },
    email: {
        name: 'อีเมล',
        placeholder: 'อีเมล',
        required: 'กรุณากรอกอีเมล',
        too_short: '',
        invalid: 'อีเมลไม่ถูกต้อง',
    },
    idCard: {
        name: 'เลขบัตประชาชน',
        placeholder: 'เลขบัตประชาชน',
        required: 'กรุณากรอกเลขบัตประชาชน',
        too_short: 'กรุณากรอกเลขบัตประชาชน 13 หลัก',
        invalid: 'เลขบัตรประชาชนไม่ถูกต้อง',
    },
    password: {
        name: 'รหัสผ่าน',
        placeholder: 'รหัสผ่าน',
        required: 'กรุณากรอกรหัสผ่าน',
        too_short: '',
        invalid: '',
    },
    gender: {
        name: 'เพศ',
        placeholder: 'กรุณาเลือก',
        required: 'กรุณาเลือกเพศ',
        too_short: '',
        invalid: '',
    },
    birthdate: {
        name: 'วันเกิด',
        placeholder: '',
        required: 'กรุณาเลือกวันเกิด',
        too_short: '',
        invalid: 'กรุณาเลือกใันที่ให้ถูกต้อง',
        date: {
            name: '',
            placeholder: 'วัน',
            required: ' '
        },
        month: {
            name: '',
            placeholder: 'เดือน',
            required: ' '
        },
        year: {
            name: '',
            placeholder: 'ปี',
            required: ' '
        },
    },
    zipcode: {
        name: 'รหัสไปรษณีย์',
        placeholder: 'รหัสไปรษณีย์',
        required: 'กรุณากรอกรหัสไปรษณีย์',
        too_short: 'รหัสไปรษณีย์ต้องมี {0} หลัก',
        invalid: 'รหัสไปรษณีย์ไม่ถูกต้อง',
    },
    subdistrict: {
        name: 'แขวง/ตำบล',
        placeholder: 'กรุณาเลือกแขวง/ตำบล',
        required: 'กรุณาเลือกแขวง/ตำบล',
        too_short: '',
        invalid: '',
    },
    district: {
        name: 'เขต/อำเภอ',
        placeholder: 'กรุณาเลือกเขต/อำเภอ',
        required: 'กรุณาเลือกเขต/อำเภอ',
        too_short: '',
        invalid: '',
    },
    province: {
        name: 'จังหวัด',
        placeholder: 'กรุณาเลือกจังหวัด',
        required: 'กรุณาเลือกจังหวัด',
        too_short: '',
        invalid: '',
    },

    male: "ชาย",
    female: "หญิง",
    notspecified: "ไม่ระบุ",

    popup_logout: {
        msg: 'คุณต้องการออกจากระบบใช่ หรือไม่',
        confirm: 'ตกลง'
    },

    i_interested: 'ฉันสนใจและต้องการรับข้อมูลข่าวสารเกี่ยวกับสินค้า บริการ ของแถม ส่วนลด โปรโมชั่น และกิจกรรมต่างๆ ที่เกี่ยวข้องจาก เบอร์เกอร์คิง และ บริษัทในเครือและแบรนด์ที่เกี่ยวข้อง',
    delete_account: 'ลบบัญชี',
    modal_delete: {
        msg: 'คุณยืนยันที่จะลบข้อมูลของคุณใช่ไหม? คุณจะไม่สามารถเข้าสู่ระบบได้ ข้อมูลและคะแนนของคุณจะถูกลบหมด',
        btn: 'ยืนยัน'
    },
    update: 'บันทึก',
};
